import { type Flags } from "@jslib/shared/flags";
import { InstallTypes, setInstallType } from "@jslib/shared/utils/getInstallType";

import {
  type Locale,
  type Options,
  type ProgramTheme,
  type ProgramThemeMessages,
  type Segment,
} from "../types/types";

import "../../scss/sheerid-iframe.scss";
import { getMessages } from "../intl/intl";
import { setProgramTheme } from "../VerificationService/ProgramTheme/ProgramTheme";
import { VerificationFormEs5 } from "../../es5Bindings/VerificationFormEs5";
import { resetOptions, setOptions } from "../../options/options";
import { resetStore } from "../VerificationService/VerificationServiceStore";
import {
  clearPreview,
  setPreviewBranding,
  setPreviewConfiguration,
  setPreviewLocale,
  setPreviewMessages,
  setPreviewMock,
  setPreviewResponse,
} from "../state/previewApi";

// MySheerID's program builder is the only consumer of this bundle, so everything
// it renders is a preview and reports itself as one.
setInstallType(InstallTypes.programBuilderPreview);

export function loadInElement(containerElement: HTMLElement, programId: string) {
  const form = new VerificationFormEs5(containerElement, programId);
  return form;
}

export function setProgramThemeChoices(theme: ProgramTheme) {
  setProgramTheme(theme);
}

export function setProgramOptions(options: Options) {
  resetStore(); // Some options (e.g. locale) aren't correctly changed without resetting the store
  setOptions(options);
}

export function resetProgramOptions() {
  resetOptions();
}

export function getFeatureFlags(callback: (flags: Flags) => void) {
  setOptions({
    _launchDarklyFlagCb: callback,
  });
}

export function getProgramMessages(
  locale: Locale,
  programThemeMessages: ProgramThemeMessages,
  segment?: Segment,
) {
  return getMessages(locale, programThemeMessages, segment);
}

// Re-exported as named exports so consumers can import them the same way as the legacy functions
// above (which are `export function`). This file is the public bundle API; jslib-internal code
// should import these from `../state/previewApi`, not from here.
export {
  setPreviewBranding,
  setPreviewConfiguration,
  setPreviewMessages,
  setPreviewResponse,
  setPreviewMock,
  setPreviewLocale,
  clearPreview,
};

export default {
  loadInElement,
  getProgramMessages,
  getFeatureFlags,
  setProgramThemeChoices,
  setProgramOptions,
  resetProgramOptions,
  setPreviewBranding,
  setPreviewConfiguration,
  setPreviewMessages,
  setPreviewResponse,
  setPreviewMock,
  setPreviewLocale,
  clearPreview,
};
